module.exports = __webpack_public_path__ + "media/images/xpass/brand_previews/yogasix-3838292d57dc0df4958f357fc1efd649.jpg";